import { InjectionToken } from '@angular/core';
import { Category } from '../../../model/catalog.model';
import { Occ } from '../../../occ/occ-models';
import { Converter } from '../../../util/converter.service';

export const CATEGORY_NORMALIZER = new InjectionToken<Converter<Occ.Category, Category>>('CategoryNormalizer');
